<template>
	<div class="main">
		<header class="page-title">
			<h2>Loopholes</h2>
			<div class="ml-auto">
				<a :href="'/' + selectedSite.slug + '/loophole/create'" class="btn btn-md btn-success"><i class="fas fa-plus"></i> Add New Loophole</a>
			</div>
		</header>
		<div class="table-reponsive">
			<table>
				<thead>
					<tr>
						<th>ID</th>
						<th>Title</th>
						<th>Shortcode</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(loophole, index) in loopholes">
						<td>{{ loophole.id }}</td>
						<td>{{ loophole.title }}</td>
						<td>[[post-object type="loophole" id="{{ loophole.id }}" /]]</td>
						<td class="nowrap">
							<a @click="copyShortcode(loophole.id)" class="btn btn-icon btn-primary"><i class="fas fa-clone" title="Copy Shortcode"></i></a>
							<a :href="'/' + selectedSite.slug + '/loophole/' + loophole.id + '/edit'" class="btn btn-icon btn-primary"><i class="fas fa-pencil-alt" title="Edit"></i></a>
							<a @click="deleteLoophole(loophole.id)" class="btn btn-icon btn-danger"><i class="fas fa-trash-alt" title="Trash"></i></a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

	</div>
</template>

<script>
import Errors from "../../Utils/Errors";

export default {
	name: "Loophole",
	props: {
		data: {
			type: Object
		}
	},
	data() {
		return {
			loopholes: this.data.loopholes,
			selectedSite: this.$selectedSite,

			errors: new Errors()
		}
	},
	methods: {
		deleteLoophole: function (id) {
			let vm = this;

			vm.$dialog.confirm('Are you sure you want to delete this Loophole?')
				.then((dialog) => {
					axios.delete('/api/' + this.$selectedSite.slug + '/loophole/' + id)
							.then(response => {
								vm.$toastr.success('Loophole deleted successfully.');
								setTimeout(function () {
									location.reload();
								}, 1000);
							})
							.catch(errors => {
								dialog.close();
								vm.$toastr.error('Loophole delete failed.', 'Error');
							});
				})
				.catch(error => {
					vm.$toastr.error('Delete aborted.');
				});
		},
		copyShortcode(id) {
			let vm = this;
			this.$clipboard('[[post-object type="loophole" id="' + id + '" /]]');
			vm.$toastr.success('Loophole shortcode copied', 'Success');
		}
	}
}
</script>

<style scoped>

</style>
